import { Check, X } from "lucide-react";
import { comparison } from "./homeData";

export function WhyLeaseFlowSection() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <p className="overline mb-3">Why LeaseFlow</p>
          <h2 className="h-display text-3xl md:text-4xl">Why not just email?</h2>
          <p className="mt-4 text-navy-600 text-lg">It's not about doing more — it's about removing the friction that's slowing your firm down today.</p>
        </div>
        <div className="card-soft overflow-hidden" data-testid="why-comparison">
          <div className="grid grid-cols-2 border-b border-navy-100">
            <div className="p-5 border-r border-navy-100">
              <p className={`font-display text-base flex items-center gap-2 ${comparison.left.className}`}>
                <X className="w-4 h-4" /> {comparison.left.name}
              </p>
            </div>
            <div className="p-5">
              <p className={`font-display text-base flex items-center gap-2 ${comparison.right.className}`}>
                <Check className="w-4 h-4" /> {comparison.right.name}
              </p>
            </div>
          </div>
          {comparison.rows.map((r) => (
            <div key={r.left} className="grid grid-cols-2 border-b border-navy-100 last:border-0">
              <div className="p-5 border-r border-navy-100 flex items-start gap-3 bg-rose-50/30">
                <r.leftIcon className="w-4 h-4 text-rose-500 shrink-0 mt-0.5" strokeWidth={2.5} />
                <span className="text-sm text-navy-700">{r.left}</span>
              </div>
              <div className="p-5 flex items-start gap-3 bg-emerald-50/40">
                <r.rightIcon className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" strokeWidth={2.5} />
                <span className="text-sm text-navy-800 font-medium">{r.right}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
